import { Amplify } from 'aws-amplify';
import { dynamicAWSConfig } from './dynamicAWSConfig';

export const awsConfigure = (config) => {
  Amplify.configure(dynamicAWSConfig(config));
};
